import * as React from "react";
const SvgFiRrMegaphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-megaphone_svg__a)">
      <path
        fill="#062147"
        d="M17 0a1 1 0 0 0-1 1c0 2.949-2.583 4-5 4H4a4 4 0 0 0-4 4v2a3.98 3.98 0 0 0 1.514 3.109l3.572 7.972A3.23 3.23 0 0 0 8.039 24a2.982 2.982 0 0 0 2.72-4.2l-2.2-4.8H11c2.417 0 5 1.051 5 4a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1M8.937 20.619A.983.983 0 0 1 8.039 22a1.23 1.23 0 0 1-1.126-.734L4.105 15h2.254zM16 14.6a7.72 7.72 0 0 0-5-1.6H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h7a7.72 7.72 0 0 0 5-1.595zm7.9.852a1 1 0 0 1-1.342.448l-2-1a1 1 0 1 1 .894-1.79l2 1a1 1 0 0 1 .448 1.337zm-3.79-9a1 1 0 0 1 .448-1.342l2-1a1 1 0 0 1 .894 1.79l-2 1a1 1 0 0 1-1.342-.448M20 10a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-megaphone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMegaphone;
